import assert from '@/sui/tools/assert'

const iconBase = {
  created: '➕',
  edited: '✏️',
  uploaded: '📎',
  validated: '✅',
  refused: `❌`,
  reg: '🧑🏻‍⚕️',
  dir: '👔',
  bio: '‍🦠'
}

const icons = {
  mainStatus: [
    iconBase.created, iconBase.edited, iconBase.uploaded, iconBase.validated
  ],

  surveillanceStatus: [
    iconBase.created,
    iconBase.uploaded,
    iconBase.validated,
    iconBase.refused,
    iconBase.edited
  ],

  roleStatus: [
    '', iconBase.edited, iconBase.uploaded, iconBase.validated
  ]
}

function getConventionStatusDisplay (i) {
  assert.isNumber(i)
  assert(i >= 0 && i < icons.mainStatus.length)
  const result = icons.mainStatus[i]
  return `Charte&nbsp;&nbsp;&nbsp;&nbsp;${result}`
}

function getSurveillanceStatusDisplay (year, i) {
  assert.isNumber(year)
  assert.isNumber(i)
  assert(i >= 0 && i < icons.surveillanceStatus.length)

  const result = icons.surveillanceStatus[i]
  return `<strong>${year}</strong> ${result}`
}

function getRoleDisplay (r) {
  assert.isString(r)
  const result = iconBase[r]
  assert.notNull(result)
  return result
}

function getRoleStatusDisplay (i) {
  assert.isNumber(i, `Not a number ${i}`)
  assert(i >= 0 && i < icons.roleStatus.length)
  const result = icons.roleStatus[i]
  if (result !== '') {
    return `Avenant&nbsp;${result}`
  }
  return result
}

export default {
  icons: iconBase,

  display: {
    conventionStatus: getConventionStatusDisplay,
    surveillanceStatus: getSurveillanceStatusDisplay,
    role: getRoleDisplay,
    roleStatus: getRoleStatusDisplay
  }
}
